<app-loader></app-loader>
<router-outlet><app-spinner></app-spinner></router-outlet>
<notifier-container></notifier-container>
